import { render, staticRenderFns } from "./CustomerSynopsis.vue?vue&type=template&id=3d1a3c3a&scoped=true&"
import script from "./CustomerSynopsis.vue?vue&type=script&lang=js&"
export * from "./CustomerSynopsis.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSynopsis.vue?vue&type=style&index=0&id=3d1a3c3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1a3c3a",
  null
  
)

export default component.exports